module.exports = __webpack_public_path__ + "static/media/tw.89a1429a.svg";